<template>
    <div :class=" { 'is-active': isOpen }" class="dropdown is-relative width-100percent">
      <div class="dropdown-trigger width-100percent">
        <b-field
          :label="label"
          :type="typeNomCommercial"
          class="obligatoire">
            <b-input
              :value="nomCommercial"
              @input="inputHandler"
              :loading="isFetching"
              @focus="isFocus = true"
              @blur="blurHandler">
            </b-input>
        </b-field>
      </div>
      <div
        class="dropdown-menu min-width-100"
        id="dropdown-menu"
        role="menu"
        @mouseover="isHoverDrop = true"
        @mouseleave="isHoverDrop = false">
        <div class="dropdown-content max-height-30-vh overflow-y-auto">
          <div v-for="(item, key, index) in formatedTierResult" :key="key">
            <h1
              class="mg-3 has-text-grey"
              v-if="hasMoreThanOneResultFormatedTier && item.length > 0">
                {{ formatSectionLibelle(key) }}
            </h1>
            <tier-nom-commercial-input-select-item
                v-for="option in item"
                :key="option.id"
                class="dropdown-item"
                @openTab="isFocus = false"
                :option="option"
                :path="getPath(key) || path">
            </tier-nom-commercial-input-select-item>
            <hr
              v-if="hasMoreThanOneResultFormatedTier && !isLast(index) && item.length > 0"
              class="dropdown-divider">
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import debounce from 'lodash/debounce';
import gestionType from '@/services/general/gestionType';
import { getAll } from '@/api/tiers/index';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import * as tiersConf from '@/configuration/tiers/tiersConf';
import messageErreur from '@/services/general/messageErreur';
import tierNomCommercialInputSelectItem from '@/components/general/input/tierNomCommercialInput/tierNomCommercialInputSelectItem';

export default {
  name: 'InputTierNomCommercial',
  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    tierId: {
      type: String,
      default: '',
    },
    query: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      tiers: [],
      isFetching: false,
      isFocus: false,
      isHoverDrop: false,
    };
  },
  components: {
    tierNomCommercialInputSelectItem,
  },
  computed: {
    nomCommercial: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    typeNomCommercial() {
      return gestionType(this.nomCommercial, this.error);
    },
    isOpen() {
      return (this.tiers.length > 0 && !this.isFetching && this.isFocus) || false;
    },
    sousTypeContent() {
      return this.query.sousType.reduce((a, value) => ({ ...a, [`${value}`]: [] }), {});
    },
    formatedTierResult() {
      const sortTab = this.tiers.reduce((a, tier) => {
        const name = tier.sousTypes[0];
        if (a[`${name}`]) {
          return { ...a, [`${name}`]: [...a[`${name}`], tier] };
        }
        return { ...a, [`${name}`]: [tier] };
      }, this.sousTypeContent);
      return sortTab;
    },
    hasMoreThanOneResultFormatedTier() {
      return Object.keys(this.formatedTierResult).map(t => t).length > 1;
    },
  },
  methods: {
    blurHandler() {
      if (!this.isHoverDrop) this.isFocus = false;
    },
    isLast(index) {
      return index === Object.keys(this.formatedTierResult).map(t => t).length - 1;
    },
    getPath(key) {
      return tiersConf.LISTE_SOUS_TYPE_FOURNISSEUR_ALL.find(
        st => st.code === key,
      )?.routeConsultation;
    },
    inputHandler(value) {
      this.nomCommercial = value;
      if (value === '') this.tiers = [];
      this.getAsyncTierData();
    },
    formatSectionLibelle(title) {
      return this.$t(tiersConf.LISTE_SOUS_TYPE_FOURNISSEUR_ALL.find(st => st.code === title)?.libelle) || 'Section';
    },
    formatQuery(query) {
      query.sousType = tiersConf.LISTE_SOUS_TYPE_FOURNISSEUR_ALL.map(stf => stf.code);
    },
    getAsyncTierData: debounce(async function tierData() {
      if (!this.nomCommercial && !this.nom) return;
      this.isFetching = true;
      this.formatQuery(this.query);
      try {
        this.tiers = (await getAll({
          query: this.query,
        })).data.result.items.map(tier => {
          if (tier.id !== this.tierId) {
            tier.libelleNomCommercial = tier.code + ' - ' + tier.nomCommercial + ' - ' + adressFullStringGetter(tier.adressePostale);
            if (tier.compteComptable) {
              tier.libelleNomCommercial += ' - ' + tier.compteComptable;
            }
          }
          return tier;
        });
        this.isFetching = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetching = false;
      }
      if (this.tiers.find(t => t.id === this.tierId)) {
        this.tiers.splice(this.tiers.findIndex(t => t.id === this.tierId), 1);
      }
    }, 500),
  },
};
</script>

<style>

</style>
